export default __webpack_public_path__ + "static/media/english-to-vietnamese-mobile-1.9b6d9ddc.png";